<template>
    <div class="vrm-filter_options__text-search">
        {{
            i18n
                ? $t(i18n, {
                      i18nFallback: label,
                  })
                : label
        }}
        <label class="vrm-filter_options__text-search__label">
            {{
                $t('general.search', {
                    i18nFallback: 'Search',
                })
            }}
            <input v-model="value" type="text" placeholder="Search text" @keyup.enter="submit" />
        </label>
    </div>
</template>

<script>
import { Vue, Prop, Model, Component } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('general')
export default class VrmInstallationOverviewFilterTextSearch extends Vue {
    @Model('input')
    model;
    @Prop({ type: String, default: '', required: false })
    label;
    @Prop({ type: String, default: undefined, required: false })
    i18n;

    submit() {
        this.$emit('submit');
    }

    get value() {
        return this.model;
    }

    set value(value) {
        this.$emit('input', value);
    }
}
</script>
